module.exports = __webpack_public_path__ + "img/no_guarda_app.4256cb48.svg";